import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class MathOperators extends ASTBlock {
    constructor(color) {
        super(color, "math_operators")
        this.predefinedInputs = {
            "arg0": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            },
            "arg1": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            }
        }
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "%1 %2 %3",
            "args0": [{
                    "type": "input_value",
                    "name": "arg0",
                    "check": "Number"
                },
                {
                    "type": "field_dropdown",
                    "name": "operator",
                    "options": [
                        [
                            "+",
                            "+"
                        ],
                        [
                            "-",
                            "-"
                        ],
                        [
                            "*",
                            "*"
                        ],
                        [
                            "/",
                            "/"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "arg1",
                    "check": "Number"
                }
            ],
            "output": "Number",
            "inputsInline": true
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}